import { BasicRequest } from "./basicRequest";

export class PublishAllocationDefinitionRequest extends BasicRequest{
    public allocationDefinitionId!:number;
    public published:boolean = false;

    constructor(){
        super();
    }
}